import {
  getAgentToken, refreshSalesToken, SALES_SESSION_EXPIRED_ERROR_CODE,
} from '@sky-distribution/gp-onboarding-shared-utils';
import { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';

type RetriableRequestConfig = InternalAxiosRequestConfig & { salesTokenRefreshed?: boolean };

type ErrorResponseBody = { error?: { errorCode?: string } };

const isSalesSessionExpired = (error: AxiosError): boolean => (
  (error.response?.data as ErrorResponseBody | undefined)?.error?.errorCode === SALES_SESSION_EXPIRED_ERROR_CODE
);

export const retryWithRefreshedSalesToken = (
  instance: AxiosInstance,
  sentAgentToken: string | undefined,
) => async (error: AxiosError) => {
  const config = error.config as RetriableRequestConfig | undefined;

  if (!isSalesSessionExpired(error) || !config || config.salesTokenRefreshed) {
    throw error;
  }

  const currentAgentToken = getAgentToken();
  const refreshedMeanwhile = !!currentAgentToken && currentAgentToken !== sentAgentToken;

  if (!refreshedMeanwhile && !(await refreshSalesToken())) {
    throw error;
  }

  return instance.request({ ...config, salesTokenRefreshed: true } as RetriableRequestConfig);
};
